import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaFacebookF, FaInstagram } from 'react-icons/fa';

import homeicon from '../../assests/karaicon.svg';
import contactSectionBg from '../../assests/contactSectionBg.png';
import Footer from '../Footer';

const Contact = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    showroomLocation: '',
    subject: '',
    message: ''
  });
  
  // Add states for form submission handling
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    type: '', // 'success' or 'error'
    message: ''
  });

  const headerTitleRef = useRef(null);
  const leftColumnRef = useRef(null);
  const rightColumnRef = useRef(null);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    
    // Clear any previous status messages when user starts typing
    if (submitStatus.message) {
      setSubmitStatus({ type: '', message: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset previous status
    setSubmitStatus({ type: '', message: '' });
    setIsSubmitting(true);

    // Prepare the API payload according to the required format
    const apiPayload = {
      fullName: formData.firstName, // Using firstName as fullName based on API structure
      lastName: formData.lastName || "",
      showRoomLocation: formData.showroomLocation || "",
      email: formData.email,
      phoneNumber: formData.phone,
      subject: formData.subject || "",
      Message: formData.message
    };

    try {
      const response = await fetch('https://www.whysocial.in/kara-contact-api/contactReq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiPayload)
      });

      const data = await response.json();

      if (response.ok) {
        // Success - Show success message and reset form
        setSubmitStatus({
          type: 'success',
          message: '✓ Thank you for contacting us! Your message has been successfully submitted. Our team will get back to you within 24-48 hours.'
        });
        
        // Reset form after successful submission
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          showroomLocation: '',
          subject: '',
          message: ''
        });
        
        // Scroll to the form section to show the success message
        rightColumnRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
      } else {
        // API returned an error
        setSubmitStatus({
          type: 'error',
          message: data.message || 'Something went wrong. Please try again later or contact us directly at contact@thestudiokara.com'
        });
      }
    } catch (error) {
      // Network or other error
      console.error('Form submission error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'Unable to submit your message at this time. Please check your internet connection and try again, or contact us directly at contact@thestudiokara.com'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className="contact-navbar">
        <div className="contact-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="contact-logo-icon" />
          </Link>
        </div>
        <div className="contact-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="contact-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="contact-nav-overlay">
          <div className="contact-nav-close" onClick={toggleMenu}>
            <IoClose className="contact-close-icon" />
          </div>
          <nav className="contact-navigation">
            <ul className="contact-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
               {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li className="active"><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero */}
      <section className="contact-section-1">
        <div className="contact-section-1-background">
          <img src={contactSectionBg} alt="Contact Background" className="contact-section-1-bg-image" />
        </div>
        <div className="contact-section-1-overlay"></div>
        <div className="contact-section-1-content">
          <p className="contact-section-1-label">Contact Us</p>
          <h1 className="contact-section-1-title">
            Custom design requests, collaborations, and consultations
          </h1>
        </div>
      </section>

      {/* SECTION 2: Contact Form & Info */}
      <main className="contact-section-2">
        <div className="contact-section-2-content-wrapper">
            
          {/* Left Column - Contact Information */}
          <div ref={leftColumnRef} className="contact-section-2-left-column reveal-section reveal-left">
            
            {/* Contact Details */}
            <div className="contact-section-2-info-section">
              <h3 className="contact-section-2-info-title">we are excited for opportunity to craft your dream space</h3>

              {/* Locations */}
            <div className="contact-section-2-info-section">              
              {/* Chennai */}
              <div className="contact-section-2-info-item">
                <FaMapMarkerAlt className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>5/44, Flat 2B, Shambu Residency,</p>
                  <p>North Boag Road, Lakshmi Colony,</p>
                  <p>T. Nagar, Chennai - 600017</p>
                </div>
              </div>

              {/* Cochin */}
              <div className="contact-section-2-info-item">
                <FaMapMarkerAlt className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>1A, Platinum Tower,</p>
                  <p>Palachuvadu Jn, Kakkanad,</p>
                  <p>Cochin - 682037</p>
                </div>
              </div>

              {/* Telangana */}
              <div className="contact-section-2-info-item">
                <FaMapMarkerAlt className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>Level 2, Plot No: 32,</p>
                  <p>Ndoyens Township,</p>
                  <p>Serilingampalli (M), Telangana - 500019</p>
                </div>
              </div>
            </div>
              
              {/* Phone Numbers */}
              <div className="contact-section-2-info-item">
                <FaPhoneAlt className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>+91 9746498260, +91 8606012200</p>
                </div>
              </div>

              {/* Email */}
              <div className="contact-section-2-info-item">
                <FaEnvelope className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>contact@thestudiokara.com</p>
                </div>
              </div>

              {/* Website */}
              <div className="contact-section-2-info-item">
                <FaGlobe className="contact-section-2-icon" />
                <div className="contact-section-2-info-text">
                  <p>thestudiokara.com</p>
                </div>
              </div>
            </div>

            {/* Divider Line */}
            <div className="contact-section-2-divider"></div>
            {/* Social Presence */}
            <div className="contact-section-2-info-section">
              <h3 className="contact-section-2-info-title">Social Presence</h3>
              <div className="contact-section-2-social-icons">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="contact-section-2-social-link">
                  <FaFacebookF className="contact-section-2-social-icon" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="contact-section-2-social-link">
                  <FaInstagram className="contact-section-2-social-icon" />
                </a>
              </div>
            </div>

          </div>

          {/* Right Column - Contact Form */}
          <div ref={rightColumnRef} className="contact-section-2-right-column reveal-section reveal-right">
            
            {/* Header Title - Now inside right column */}
            <div className="contact-section-2-header">
              <h2 className="contact-section-2-main-title">Begin Your Bespoke Journey</h2>
              <p className="contact-section-2-description">
                Share your vision with us—whether it's a custom piece, a collaboration, or a consultation. Let's bring timeless design to life.
              </p>
            </div>

            {/* Status Messages */}
            {submitStatus.message && (
              <div className={`contact-form-status ${submitStatus.type === 'success' ? 'contact-form-status-success' : 'contact-form-status-error'}`}>
                {submitStatus.message}
              </div>
            )}

            <div className="contact-section-2-form-wrapper">
              <form className="contact-section-2-form" onSubmit={handleSubmit}>
                
                {/* First Name & Last Name */}
                <div className="contact-section-2-form-row">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="contact-section-2-input"
                    required
                    disabled={isSubmitting}
                  />
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="contact-section-2-input"
                    disabled={isSubmitting}
                  />
                </div>

                {/* Email & Phone */}
                <div className="contact-section-2-form-row">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="contact-section-2-input"
                    required
                    disabled={isSubmitting}
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="contact-section-2-input"
                    required
                    disabled={isSubmitting}
                  />
                </div>

                {/* Showroom Location */}
                <div className="contact-section-2-form-row">
                  <input
                    type="text"
                    name="showroomLocation"
                    placeholder="Showroom Location"
                    value={formData.showroomLocation}
                    onChange={handleInputChange}
                    className="contact-section-2-input contact-section-2-input-full"
                    disabled={isSubmitting}
                  />
                </div>

                {/* Subject */}
                <div className="contact-section-2-form-row">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="contact-section-2-input contact-section-2-input-full"
                    disabled={isSubmitting}
                  />
                </div>

                {/* Message */}
                <div className="contact-section-2-form-row">
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="contact-section-2-textarea"
                    rows="6"
                    required
                    disabled={isSubmitting}
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className={`contact-section-2-submit-button ${isSubmitting ? 'submitting' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                </button>
              </form>
            </div>

          </div>

        </div>
      </main>

      <Footer />
    </>
  );
};

export default Contact;